import React, { useEffect ,useState} from "react";
import { Button, Empty, Badge } from "antd";
import { useNavigate } from "react-router-dom";

import useStatsStore from "../../store/stats.store";

import "./myDashboardPages.scss";
import MyDashBoardResumeSharing from "./myDashBoardResumeSharing";
import MyDashBoardPositiveFeedbacks from "./myDashBoardPositiveFeedbacks";
import MyDashBoardInterviewScheduling from "./myDashBoardInterviewScheduling";
import MyDashBoardNegativeFeedbacks from "./myDashBoardNegativeFeedbacks";
import MyDashBoardSelectionsAndOffers from "./myDashBoardSelectionsAndOffers";

export default function MyDashBoardPages(props) {
  const navigate = useNavigate();
  const [currentView, setCurrentView] = useState("Resume Sharing"); 
  const {myDashConsolidatedStats,getMyDashBoardConsolidatedStats} = useStatsStore();
  
  const {myDashConsolidatedStatsResumesSharedCount,getMyDashBoardConsolidatedStatsResumesShared} = useStatsStore();
  const {myDashConsolidatedStatsPositiveFeedbackCount,getMyDashBoardConsolidatedStatsPositiveFeedbacks} = useStatsStore();
  const {myDashConsolidatedStatsInterviewSchedulingCount,getMyDashBoardConsolidatedStatsInterviewScheduling} = useStatsStore();
  const {myDashConsolidatedStatsNegativeFeedbackCount,getMyDashBoardConsolidatedStatsNegativeFeedback} = useStatsStore();
  const {myDashConsolidatedStatsSelectionAndOffersCount,getMyDashBoardConsolidatedStatsSelectionAndOffers} = useStatsStore();
  
  
  useEffect(() => {
     //To Do
  }, []);

  const myDashBoardPagesCallback = (filterDuration,encodedJsonValues ) =>{   
    getMyDashBoardConsolidatedStatsResumesShared(filterDuration, encodedJsonValues)     
    getMyDashBoardConsolidatedStatsPositiveFeedbacks(filterDuration, encodedJsonValues)
    getMyDashBoardConsolidatedStatsInterviewScheduling(filterDuration, encodedJsonValues)
    getMyDashBoardConsolidatedStatsNegativeFeedback(filterDuration, encodedJsonValues)
    getMyDashBoardConsolidatedStatsSelectionAndOffers(filterDuration, encodedJsonValues)
  }
  return (
    <div className="myDashboard-wrapper">    
      <div className="myAssignmentPages-btns">
        <Badge
          count={myDashConsolidatedStatsResumesSharedCount > 0 ? myDashConsolidatedStatsResumesSharedCount : "0"}
          color="#0091ff9a"
          style={{ zIndex: 2 }}
          offset={[-5, 5]}
        >
      <Button
        onClick={() => {
            setCurrentView("Resume Sharing");
            //   navigate(`/jds/${value}`);
        }}
        className={`jd-form-option-btn ${
        currentView === "Resume Sharing" &&"jd-form-option-btn-active"
        }`}
      >
            Resume Sharing
      </Button>   
        </Badge>
        <Badge
          count={
            myDashConsolidatedStatsPositiveFeedbackCount > 0 ? myDashConsolidatedStatsPositiveFeedbackCount : "0"
          }
          color="#4f9301dd"
          style={{ zIndex: 2 }}
          offset={[-5, 5]}
        >
      <Button
        onClick={() => {
            setCurrentView("Screen/Interview Selections");
            //   navigate(`/jds/${value}`);
        }}
  
        className={`jd-form-option-btn ${
        currentView === "Screen/Interview Selections" &&"jd-form-option-btn-active"
        }`}
      >
            Positive Feedbacks
      </Button>    
        </Badge>
        <Badge
          count={
            myDashConsolidatedStatsInterviewSchedulingCount > 0
              ? myDashConsolidatedStatsInterviewSchedulingCount
              : "0"
          }
          color="#dbe51cc7"
          style={{ zIndex: 2 }}
          offset={[-5, 5]}
        >
      <Button
        onClick={() => {
            setCurrentView("Interview Scheduling/Rescheduling");
            //   navigate(`/jds/${value}`);
        }}
        className={`jd-form-option-btn ${
        currentView === "Interview Scheduling/Rescheduling" &&"jd-form-option-btn-active"
        }`}
      >
            Interview Scheduling
      </Button> 
        </Badge>

        <Badge
          count={
            myDashConsolidatedStatsNegativeFeedbackCount > 0 ? myDashConsolidatedStatsNegativeFeedbackCount : "0"
          }
          color="#ff08009a"
          style={{ zIndex: 2 }}
          offset={[-5, 5]}
        >
      <Button
        onClick={() => {
            setCurrentView("Rejections/No Shows");
            //   navigate(`/jds/${value}`);
        }}
        className={`jd-form-option-btn ${
        currentView === "Rejections/No Shows" &&"jd-form-option-btn-active"
        }`}
      >
            Negative Feedbacks
      </Button> 
        </Badge>
        <Badge
          count={
            myDashConsolidatedStatsSelectionAndOffersCount > 0 ? myDashConsolidatedStatsSelectionAndOffersCount : "0"
          }
          color="#00ff339a"
          style={{ zIndex: 2 }}
          offset={[-5, 5]}
        >
            <Button
              onClick={() => {
                  setCurrentView("Final Selections/Offers");
                  //   navigate(`/jds/${value}`);
              }}
              className={`jd-form-option-btn ${
              currentView === "Final Selections/Offers" &&"jd-form-option-btn-active"
              }`}
            >
                  Final Selections/Offers
            </Button>  
        </Badge>
      </div>

      {
        currentView==="Resume Sharing"? <MyDashBoardResumeSharing currentView={currentView} cb = {myDashBoardPagesCallback} />:
        currentView==="Screen/Interview Selections"? <MyDashBoardPositiveFeedbacks currentView={currentView} cb={myDashBoardPagesCallback} />:
        currentView==="Interview Scheduling/Rescheduling"? <MyDashBoardInterviewScheduling currentView={currentView} cb={myDashBoardPagesCallback} />:
        currentView==="Rejections/No Shows"? <MyDashBoardNegativeFeedbacks currentView={currentView} cb={myDashBoardPagesCallback} />:
        currentView==="Final Selections/Offers"? <MyDashBoardSelectionsAndOffers currentView={currentView} cb={myDashBoardPagesCallback} />:
        <></>
      }          
    </div>
  );
}
